import { AllTranscriptsProps } from '@/types';

export const getConversationId = (transcript: AllTranscriptsProps | null) => {
  if (!transcript) return null;

  const { language, conversation_id, _id } = transcript;
  return language ? conversation_id ?? null : _id ?? null;
};
